import Vue from 'vue';
import gridProps from '@/gridProps';

import {alignCells, autoResize, formatNumber} from "@/helpers/renderHelpers";

import {
  addColIdToColumns,
  handlerResponse,
  sumTotalData
} from '@/helpers/commonHelpers';
import { addComparatorsToCol } from '@/helpers/grid-helpers';

const cellStyle = (params) => {
  const numericColumns = ['width', 'length', 'thickness'];
  return alignCells(params, numericColumns.includes(params.colDef.field) && 'right');
};

export default {
  namespaced: true,
  state: {
    products: [],
    columns: [],
    gridOptions: {
      rowGroupPanelShow: 'always',
      animateRows: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        enableValue: true,
        enableRowGroup: true,
        valueFormatter(params) {
          return formatNumber(params.value, null);
        },
        cellStyle,
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        } else {
          this.api && this.api.hideOverlay();
          this.api && this.api.showNoRowsOverlay();
        }
      },
      onGridReady() {
        if (!this.rowData.length) {
          this.api.showNoRowsOverlay();
        }
      }
    },
    gridName: 'products_search'
  },
  getters: {
    gridOptions(state) {
      return {...state.gridOptions, ...gridProps};
    },
    columns(state) {
      return state.columns.map(item => addComparatorsToCol(item));
    },
  },
  mutations: {
    setData(state, payload) {
      state.products = payload.data;
      state.columns = addColIdToColumns(payload.used_columns);
      state.gridName = payload.grid_name
    }
  },
  actions: {
    loadProducts({getters, commit}, payload) {
      return new Promise(resolve => {
        if (getters.gridOptions.api) {
          getters.gridOptions.api.showLoadingOverlay();
        }
        const params = {
          ...payload
        };
        Vue.http.get('woodware/search_for_products/', {params})
          .then(handlerResponse)
          .then(data => {
            commit('setData', data);
            resolve(data);
          });
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/general/products/products.js